import React, { Component } from 'react'
import { connect } from 'react-redux'

import type { Track } from 'types/track'
import type { User } from 'types/user'

import { sendGenericError } from '@disco/state-management/actions/error-actions'

import { getUser } from '@disco/state-management/selectors/user'
import NativeTagsPopover from 'components/common/native-tags-popover'

type Props = {
  onClose: (...args: Array<any>) => any
  track: Track
  user: User
  type: string
  sendGenericError: typeof sendGenericError
}

class TrackTagModal extends Component<Props> {
  constructor(props: Props) {
    super(props)
    const { track } = this.props
  }

  render() {
    const { track } = this.props
    if (!track) return null

    return (
      <NativeTagsPopover
        trackIds={[this.props.track.id]}
        assignedTags={this.props.track.native_tags || []}
        onClose={this.props.onClose}
      />
    )
  }
}

export default connect(
  state => ({
    user: getUser(state),
  }),
  { sendGenericError },
)(TrackTagModal)
